import http from "../http"
export default {
  // 首页Banner
  getBannerList(param) {
    return http.get("/api/banner/list", param)
  },
  // 集团概述 + 板块业务 + 联系我们
  // 板块业务资源 id，顺序为：简介 / 数字 / 产品 / 相关成员单位（数字=数字栏 listInfo，产品=pageConfigList，成员=article/list）
  // 新能源板块 126/142/143/127、航空航天复材制造板块 129/140/141/130、海洋船舶及相关制造 159/160/161/162
  // 其他装备制造板块 169/170/171/172、工美文化 164/165/166/167、军工板块 135/146/147/136
  // 民爆板块 132/144/145/133、产业服务板块 174/175/176/177
  // 首页板块业务与门户页头/页脚取「简介」；板块页四类都用，见 src/views/blockBusiness/index.vue 的 menuList
  getPageConfigDetail(resourceId, param) {
    return http.get("/api/pageConfig/getPageConfigDetail/" + resourceId, param)
  },
  // 集团要闻 + 成员动态 + 媒体聚焦 + 企业文化（党群之窗） + 信息公开
  getArticleList(param) {
    return http.get("/api/article/page", param)
  },
  // 数字信息
  getSzInfoList(param) {
    return http.get("/api/listInfo/list", param)
  },
  // 成员单位
  getMemberUnitList(param) {
    return http.get("/api/memberUnit/list", param)
  },
  // 专题专栏
  getZtzlList(param) {
    return http.get("/api/article/list", param)
  },
  // 获取信息列表（人才招聘 + 公式公告）
  getPageListByType(param) {
    return http.get(`/api/info/pageListByType`, param);
  },
  // 获取社会责任列表
  getPageSocialResponsibility(param) {
    return http.get(`/api/info/pageSocialResponsibility`, param);
  },
}